/* --------------------------------------------------------------------------
	Faculty Cards
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-faculty-list').length) {
			return;
		}

		onResize();

		$('.js-faculty-card-expertise-toggle').on('activate.swap', onToggleSwapActivate).on('deactivate.swap', onToggleSwapDeactivate);

		$('.js-faculty-card-extra-toggle').on('activate.swap', onMoreSwapActivate);

		Site.OnResize.push(onResize);
	}

	function onToggleSwapActivate() {
		$(this).attr('aria-expanded', 'true').closest('.js-faculty-card').addClass('active');
	}

	function onToggleSwapDeactivate() {
		var $card = $(this).closest('.js-faculty-card');

		$(this).attr('aria-expanded', 'false');
		$card.find('.js-faculty-card-expertise-info').transition({ always: false, property: 'opacity' }, function () {
			$card.removeClass('active');
		});
	}

	function onResize() {
		$('.js-faculty-card-inner').each(function () {
			var height = $(this).innerHeight();

			$(this)
				.closest('.js-faculty-card')
				.get(0)
				.style.setProperty('--card-height', height + 'px');
		});

		$('.js-faculty-card-expertise-info').each(function () {
			var height = $(this).innerHeight();

			$(this)
				.closest('.js-faculty-card-expertise-data')
				.get(0)
				.style.setProperty('--expertise-height', height + 'px');
		});
	}

	function onMoreSwapActivate() {
		onResize();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
